import IMessage from "../../shared/interfaces/message.interface";

export const MESSAGE_LOGIN: IMessage = {
    textMessage: "Credenciales inválidas, intenta nuevamente",
    style: "danger",
    open: '',
    duration: 2000
}